module.exports = __webpack_public_path__ + "img/Edenkia_80X30.ce5bb10a.png";